import { render } from "./user-hello.vue?vue&type=template&id=5f415110&scoped=true"
import script from "./user-hello.vue?vue&type=script&lang=js"
export * from "./user-hello.vue?vue&type=script&lang=js"

import "./user-hello.vue?vue&type=style&index=0&id=5f415110&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f415110"]])

export default __exports__